const productItem = () => {
    const classes = {
        variantOptionActive: 'variant-option--active',
    };
    const selectors = {
        productItem: '[data-lbdo-product-item]',
        variantOption: '[data-lbdo-product-item-variant-option]',
    };
    const productItems = document.querySelectorAll(selectors.productItem);
    productItems.forEach((item) => {
        const variantOptions = item.querySelectorAll(selectors.variantOption);
        variantOptions.forEach((option) => {
            option.addEventListener('click', () => {
                variantOptions.forEach((otherOption) => {
                    otherOption.classList.remove(classes.variantOptionActive);
                });
                option.classList.add(classes.variantOptionActive);
            });
        });
    });
};
export { productItem };
